import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QRCodeDetail } from 'src/app/interfaces/qr-code';

import { DataMappingService } from 'src/app/services/data-mapping.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PetDetail } from '../../interfaces/pet';
import { SafeUrl } from '@angular/platform-browser';
// import QRCode from 'qrcode';
import * as QRCode from 'qrcode';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-qr-code-detail',
  templateUrl: './qr-code-detail.component.html',
  styleUrls: ['./qr-code-detail.component.scss']
})
export class QRCodeDetailComponent implements OnInit, OnDestroy {
  // modalRef: BsModalRef;
  selectedQRCode: any;
  public qrCodeDetailForm: FormGroup;
  isLoading = false;
  // qrCodeTypes: QRCodeType[] = [];
  selectedQRCodeType: any;
  isNew = false;
  qrCodeUpdateData = new FormData();
  isSavingQRCode = false;
  public onClose= new Subject<boolean>();
  nationalityList: string[] = [];
  selectedNationality= '';
  referralList: string[] = [];
  selectedReferral= '';
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;
  qrData: string='';
  showCopiedMessage: boolean = false;
  availablePets = [] as PetDetail[];
  selectedPet = {} as PetDetail;
  isPetsLoaded = false;
  selectedPetId = '';
  // Get the base URL (protocol + hostname + port)
  baseUrl = `${window.location.origin}/#/public-qr-code`;
  public qrCodeDownloadLink: SafeUrl = "";
  // Reference to the QR code element
  @ViewChild('qrCodeElement', { static: false }) qrCodeElement!: ElementRef;

  editorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '500px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image', 'video'],
    ],
  };

  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {
    this.nationalityList = this.jsonDataService.jsonNationality;
    this.referralList = this.jsonDataService.jsonReferralSource;
    this.getPets();
    
    this.qrCodeDetailForm = this.formBuilder.group({
      id: '',
      petId: '',
      petName: '',
      ownerFirstName: '',
      ownerLastName: '',
      isSharePetName: [false],
      isSharePetGender: [false],
      isSharePetImage: [false],
      isShareOwnerFirstName: [false],
      isShareOwnerLastName: [false],
      isShareOwnerPhone: [false],
      isShareOwnerEmail: [false],
      isShareOwnerEmergencyContact: [false],
      message: '',
      originalUrl: '',
      shortUrl: '',
    });
    // this.qrCodeDetailForm.get('howDidYouHearAboutGoodDog')?.valueChanges.subscribe(value => {
    //   console.log('howDidYouHearAboutGoodDog option changed:', value);
    //   this.selectedReferral = value;
    // });
    this.editor = new Editor();
  }

  ngOnInit(): void {
    // Retrieve qrCode types
    // this.getQRCodeTypes();
    // this.editor = new Editor();
    // this.getPets();
    console.log(`QRCodeDetailComponent, ngOnInit, availablePets: ${JSON.stringify(this.availablePets)}`);
    console.log(`QRCodeDetailComponent, ngOnInit, availablePets length: ${JSON.stringify(this.availablePets.length)}`);
    console.log(`QRCodeDetailComponent, ngOnInit, This is QR code detail modal`);
    console.log(`QRCodeDetailComponent, ngOnInit, isNew: ${this.isNew}`);
    if (!this.isNew) {
      console.log(`QRCodeDetailComponent, ngOnInit, selectedQRCode: ${JSON.stringify(this.selectedQRCode)}`);
      console.log(`QRCodeDetailComponent, ngOnInit, isNew: ${this.isNew}`);
      console.log(`QRCodeDetailComponent, ngOnInit, selectedQRCode.petId: ${this.selectedQRCode.petId}`);
      this.selectedPetId = this.selectedQRCode.petId;
      console.log(`QRCodeDetailComponent, ngOnInit, selectedPetId: ${this.selectedPetId}`);
      if (this.isPetsLoaded && this.availablePets != null && this.availablePets.length>0)
      {
        const foundPet = this.availablePets.find(p => p.id == this.selectedPetId);
        console.log(`QRCodeDetailComponent, ngOnInit, foundPet: ${JSON.stringify(foundPet)}`);
        if(foundPet != null) {
          console.log(`QRCodeDetailComponent, ngOnInit, Pet found`);
          this.selectedPet = foundPet;
          this.disableShareFieldsBasedOnSelectedPet();
        }
      }
      // this.disableShareFieldsBasedOnSelectedPet();
      this.selectedQRCodeType = this.selectedQRCode.type
      // const formData = this.dataMappingService()
      this.patchQRCodeDetailForm(this.selectedQRCode);
      this.qrData = this.selectedQRCode.shortUrl != null && this.selectedQRCode.shortUrl != 'null'? this.selectedQRCode.shortUrl : this.selectedQRCode.originalUrl;
      console.log(`QRCodeDetailComponent, ngOnInit, qrData: ${this.qrData}`);

      this.hasEditPermission = this.petService.hasPermission('api.change_qrcode');
      console.log(`QRCodeDetailComponent, hasEditPermission: ${this.hasEditPermission}`);
      // Disable form if user has no change QR code permission
      this.disableForm();
    }
    else {
      this.hasAddPermission = this.petService.hasPermission('api.add_qrcode');
      console.log(`QRCodeDetailComponent, hasAddPermission: ${this.hasAddPermission}`);
    }

    // Disable owner first and last name
    this.disableOwnerNameFields();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  // Ensure the view is initialized before accessing the element
  ngAfterViewInit() {
    console.log(`QRCodeDetailComponent, ngAfterViewInit`);
    // You can call downloadQRCode() here if needed
    //console.log(this.qrCodeElement);
  }

  patchQRCodeDetailForm(qrCode: QRCodeDetail) {
    this.qrCodeDetailForm.patchValue(qrCode);
    // this.qrCodeDetailForm.controls['typeId'].setValue(qrCode.type.name);
    // console.log(`QRCodeDetailComponent, howDidYouHearAboutGoodDog: ${this.selectedQRCode.howDidYouHearAboutGoodDog}`);
    // this.qrCodeDetailForm.controls['howDidYouHearAboutGoodDog'].setValue(qrCode.howDidYouHearAboutGoodDog);
    // this.qrCodeDetailForm.patchValue({
    //   name: qrCode.first_name,
    //   phone: qrCode.phone,
    //   address: qrCode.address,
    //   email: qrCode.email,
    //   emergencyContact: qrCode.emergency_contact,
    //   nationality: qrCode.nationality,
    //   howDidYouHearAboutGoodDog: qrCode.how_did_you_hear_about_good_dog,
    //   howDidYouHearAboutGoodDogOther: qrCode.how_did_you_hear_about_good_dog_other,
    //   typeId: qrCode.type.name,
    // });
  } // end of patchQRCodeDetailForm

  // getQRCodeTypes() {
  //   this.petService.getQRCodeTypes().subscribe({
  //     next: (response) => {
  //       console.log(`getQRCodeTypes, response: ${JSON.stringify(response)}`);
  //       this.qrCodeTypes = response;
  //     },
  //     error: (error) => {
  //       console.error(`getQRCodeTypes, error: ${JSON.stringify(error)}`);
  //     }
  //   });
  // } // end of getVaccines

  // onSelectQRCodeType (event: TypeaheadMatch): void{
  //   this.selectedQRCodeType = event.item;
  //   console.log(`onSelectQRCodeType, selectedQRCodeType, name:${this.selectedQRCodeType.name}, id:${this.selectedQRCodeType.id}`);
  // } // end of onSelectQRCodeType

  saveQRCode() {
    console.log(`saveQRCode, isNew:${this.isNew}`);
    if(!this.isNew) {
      if (this.hasEditPermission){
        this.updateQRCode();
      }
    } else {
      if (this.hasAddPermission){
        this.createQRCode();
      }
    }
  } // end of saveQRCode

  updateQRCode() {
    this.isSavingQRCode = true;
    this.createQRCodeUpdatePayload();
    console.log(`updateQRCode, qrCodeUpdateData:${this.qrCodeUpdateData}`);
    this.petService.updateQRCode(this.selectedQRCode.id, this.qrCodeUpdateData).subscribe({
      next: (response) => {
        this.isSavingQRCode = false;
        console.log(`updateQRCode, response: ${JSON.stringify(response)}`);
        this.hideModal();
        this.router.navigate(['qr-code']);
      },
      error: (error) => {
        this.isSavingQRCode = false;
        console.error(`updateQRCode, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingQRCode = false;
  } // end of updateQRCode

  createQRCode() {
    this.isSavingQRCode = true;
    this.createQRCodeUpdatePayload();
    console.log(`createQRCode, baseUrl: ${this.baseUrl}`);
    this.qrCodeUpdateData.append('base_url', this.baseUrl);
    console.log(`createQRCode, qrCode data:${JSON.stringify(this.qrCodeUpdateData)}`);
    this.petService.createQRCode(this.qrCodeUpdateData).subscribe({
      next: (response) => {
        this.isSavingQRCode = false;
        console.log(`createQRCode, response: ${JSON.stringify(response)}`);
        this.hideModal()
      },
      error: (error) => {
        this.isSavingQRCode = false;
        console.error(`createQRCode, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingQRCode = false;
  } // end of createQRCode

  // createQRCodeUpdatePayload() {

  // }

  // createQRCodeUpdatePayload() {
  //   Object.keys(this.qrCodeDetailForm.controls).forEach(
  //     (key) => {
  //       this.qrCodeUpdateData.set(key, this.qrCodeDetailForm.controls[key].value);
  //     }
  //   );
  //   this.qrCodeUpdateData.set("typeId", this.selectedQRCodeType.id);
  // }  // end of createQRCodeUpdatePayload

  createQRCodeUpdatePayload() {
    const formValues = this.qrCodeDetailForm.value;
    this.qrCodeUpdateData.append('pet_id', this.selectedPetId);
    this.qrCodeUpdateData.append('is_share_pet_name', formValues.isSharePetName ?? false);
    this.qrCodeUpdateData.append('is_share_pet_gender', formValues.isSharePetGender ?? false);
    this.qrCodeUpdateData.append('is_share_pet_image', formValues.isSharePetImage ?? false);
    this.qrCodeUpdateData.append('is_share_owner_first_name', formValues.isShareOwnerFirstName ?? false);
    this.qrCodeUpdateData.append('is_share_owner_last_name', formValues.isShareOwnerLastName ?? false);
    this.qrCodeUpdateData.append('is_share_owner_phone', formValues.isShareOwnerPhone ?? false);
    this.qrCodeUpdateData.append('is_share_owner_email', formValues.isShareOwnerEmail ?? false);
    this.qrCodeUpdateData.append('is_share_owner_emergency_contact', formValues.isShareOwnerEmergencyContact ?? false);
    this.qrCodeUpdateData.append('message', formValues.message);
    this.qrCodeUpdateData.append('short_url', formValues.shortUrl);
  }  // end of createQRCodeUpdatePayload

  closeModal() {
    this.hideModal();
  } // end of closeModal

  hideModal() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  // onSelectNationality (event: TypeaheadMatch): void{
  //   this.selectedNationality = event.item;
  //   console.log(`onSelectNationality, selectedNationality:${this.selectedNationality}`);
  // } // end of onSelectNationality

  // onSelectReferral (event: TypeaheadMatch): void{
  //   this.selectedReferral = event.item;
  //   console.log(`onSelectReferral, selectedReferral:${this.selectedReferral}`);
  // } // end of onSelectReferral

  disableForm(){
    if (!this.hasEditPermission) {
      this.qrCodeDetailForm.disable(); 
    }
  }

  // Method to copy qrData to clipboard
  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.qrData); // Copy text to clipboard
      this.showCopiedMessage = true; // Show feedback message
      setTimeout(() => {
        this.showCopiedMessage = false; // Hide feedback message after 2 seconds
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  getPets() {
    this.isPetsLoaded = false;
    this.petService.getPets().subscribe({
      next: (response) => {
        console.log(`getPets, response: ${JSON.stringify(response)}`);
        this.availablePets = this.dataMappingService.mapPetsDetailDataToInterfaces(response);
        // Refresh available Pets
        // this.getAvailablePets();
        this.isPetsLoaded = true;
      },
      error: (error) => {
        this.isPetsLoaded = true;
        console.error(`getPets, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getPets

  onSelectPet (event: TypeaheadMatch): void{
    this.selectedPet = event.item;
    if (this.selectedPet){
      this.selectedPetId = this.selectedPet.id;
      // this.selectedPets.push(event.item);
      console.log(`onSelectPet, selectedPet:${JSON.stringify(this.selectedPet)}`);
      this.qrCodeDetailForm.controls['ownerFirstName'].setValue(this.selectedPet.owner.firstName);
      this.qrCodeDetailForm.controls['ownerLastName'].setValue(this.selectedPet.owner.lastName);

      this.disableShareFieldsBasedOnSelectedPet();
    }
    else {
      console.log(`onSelectPet, No pet selected`);
      this.disableAllShareFields();
    }
    // Refresh available Pets
    // this.getAvailablePets();
    // Reset pet name control
    // this.resetPetNameControl();
  } // end of onSelectPet

  disableOwnerNameFields() {
    this.qrCodeDetailForm.get('ownerFirstName')?.disable();
    this.qrCodeDetailForm.get('ownerLastName')?.disable();
  }

  disableAllShareFields() {
    this.qrCodeDetailForm.get('isSharePetImage')?.disable();
    this.qrCodeDetailForm.get('isSharePetName')?.disable();
    this.qrCodeDetailForm.get('isSharePetGender')?.disable();
    this.qrCodeDetailForm.get('isShareOwnerFirstName')?.disable();
    this.qrCodeDetailForm.get('isShareOwnerLastName')?.disable();
    this.qrCodeDetailForm.get('isShareOwnerPhone')?.disable();
    this.qrCodeDetailForm.get('isShareOwnerEmail')?.disable();
    this.qrCodeDetailForm.get('isShareOwnerEmergencyContact')?.disable();
  }

  disableShareFieldsBasedOnSelectedPet() {
    if (!this.selectedPet.image){
      this.qrCodeDetailForm.get('isSharePetImage')?.disable();
    }
    if (!this.selectedPet.name){
      this.qrCodeDetailForm.get('isSharePetName')?.disable();
    }
    if (!this.selectedPet.sex){
      this.qrCodeDetailForm.get('isSharePetGender')?.disable();
    }
    if (!this.selectedPet.owner.firstName){
      this.qrCodeDetailForm.get('isShareOwnerFirstName')?.disable();
    }
    if (!this.selectedPet.owner.lastName){
      this.qrCodeDetailForm.get('isShareOwnerLastName')?.disable();
    }
    if (!this.selectedPet.owner.phone){
      this.qrCodeDetailForm.get('isShareOwnerPhone')?.disable();
    }
    if (!this.selectedPet.owner.email){
      this.qrCodeDetailForm.get('isShareOwnerEmail')?.disable();
    }
    if (!this.selectedPet.owner.emergencyContact){
      this.qrCodeDetailForm.get('isShareOwnerEmergencyContact')?.disable();
    }
  }


  // // Method to download the QR code
  // downloadQRCode() {
  //   // Get the QR code image element
  //   const qrCodeImage = this.qrCodeElement.nativeElement.querySelector('canvas');

  //   if (qrCodeImage) {
  //     // Create a temporary <a> element to trigger the download
  //     const link = document.createElement('a');
  //     link.href = qrCodeImage.src; // Use the image source as the download URL
  //     link.download = 'qrcode.png'; // Set the file name
  //     document.body.appendChild(link);
  //     link.click(); // Trigger the download
  //     document.body.removeChild(link); // Clean up
  //   } else {
  //     console.error('QR code image not found.');
  //   }
  // }

  downloadQRCode() {
    console.log(this.qrCodeElement);
    console.log(this.qrCodeElement?.nativeElement);
    if (this.qrCodeElement && this.qrCodeElement.nativeElement) {
      const canvas = this.qrCodeElement.nativeElement.querySelector('canvas');
      if (canvas) {
        const imageDataUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imageDataUrl;
        link.download = 'qrcode.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('Canvas element not found.');
      }
    } else {
      console.error('QR code element not found.');
    }
  }

  saveImgQRCodeAsImage(parent: any) {
    let parentElement = null
    parentElement = parent.qrcElement.nativeElement.querySelector("img").src
    if (parentElement) {
      // converts base 64 encoded image to blobData
      let blobData = this.convertBase64ToBlob(parentElement)
      // saves as image
      const blob = new Blob([blobData], { type: "image/png" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      // name of the file
      link.download = "angularx-qrcode"
      link.click()
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(";base64,")
    // hold the content type
    const imageType = parts[0].split(":")[1]
    // decode base64 string
    const decodedData = window.atob(parts[1])
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length)
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i)
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType })
  }

  async downloadHighResQRCode() {
    console.log("downloadHighResQRCode");;
    try {
      // Generate high-resolution QR code (e.g., 1024x1024 pixels)
      const url = await QRCode.toDataURL(this.qrData, {
        width: 1024, // Set the desired width
        margin: 2, // Add margin
      });

      // Create a download link
      const link = document.createElement('a');
      link.href = url;
      link.download = `qrcode_${this.selectedQRCode.petName}_${this.selectedQRCode.ownerFirstName}_${this.selectedQRCode.ownerLastName}.png`; // Set the file name
      document.body.appendChild(link);
      link.click(); // Trigger the download
      document.body.removeChild(link); // Clean up
    } catch (err) {
      console.error('Failed to generate QR code: ', err);
    }
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  // onEditorCreated(editor: any) {
  //   console.log(editor); // Access the Quill editor instance
  // }

  onEditorCreated(editor: any) {
    console.log(editor); // Access the editor instance
  }

  // onReferralChange(event: any) {
  //   this.selectedReferral = event.target.value;
  //   console.log(`onReferralChange, selectedReferral:${this.selectedReferral}`);
  // }
}
